import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiAlertCircle, FiEdit3 } = FiIcons;

const FamilyTreeChangeRequests = () => (
  <section
    className="rounded-3xl border border-amber-200 bg-amber-50 p-6 md:p-7"
    aria-labelledby="family-tree-change-requests-title"
  >
    <div className="flex items-start gap-4">
      <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl border border-amber-200 bg-white">
        <SafeIcon icon={FiEdit3} className="h-5 w-5 text-amber-700" />
      </div>
      <div className="min-w-0">
        <h3 id="family-tree-change-requests-title" className="font-serif text-xl text-accent-navy">
          Suggest a family tree change
        </h3>
        <p className="mt-1 text-sm leading-relaxed text-text-muted">
          Change requests are temporarily unavailable. They are not being submitted or stored.
        </p>
        <div className="mt-4 flex items-start gap-2 rounded-2xl border border-amber-200 bg-white/80 p-3 text-xs leading-relaxed text-amber-900">
          <SafeIcon icon={FiAlertCircle} className="mt-0.5 h-4 w-4 shrink-0" />
          <p>
            Secure memorial-owner routing and review permissions are not configured for this feature.
            Sign-in alone cannot verify who may review a request.
          </p>
        </div>
        <button
          type="button"
          disabled
          className="mt-4 cursor-not-allowed rounded-full border border-amber-300 bg-white px-4 py-2 text-[10px] font-black uppercase tracking-widest text-amber-800 opacity-70"
          aria-describedby="family-tree-change-requests-title"
        >
          Requests unavailable
        </button>
      </div>
    </div>
  </section>
);

export default FamilyTreeChangeRequests;